import { IMessageCodeMapping, IMessageMapping } from '../../interfaces';
import PlainMessageStrategy from './PlainMessageStrategy';

export const createPlainMessageStrategy = (
  messages: IMessageMapping,
  codeMapping: IMessageCodeMapping,
): PlainMessageStrategy => {
  return new PlainMessageStrategy(messages, codeMapping);
};
